module.exports = __webpack_public_path__ + "img/toast-header.afb8d80a.png";